import { Skeleton } from '@/components/atoms/Skeleton';
import { theme } from '@/styles/theme';

export default function PlanoPaginaDesktopFallback() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: `0 ${theme.spacing[4]}px`,
        gap: theme.spacing[5],
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          paddingTop: theme.spacing[5],
          paddingBottom: theme.spacing[4],
          gap: theme.spacing[5],
        }}
      >
        <Skeleton style={{ width: '50vw', height: 16 }} />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing[2],
          }}
        >
          <Skeleton style={{ width: 380, height: 32 }} />
          <Skeleton style={{ width: 140, height: 24 }} />
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flex: 1,
          paddingBottom: theme.spacing[5],
          gap: theme.spacing[7],
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            gap: theme.spacing[4],
          }}
        >
          <Skeleton style={{ width: 460, height: 200 }} />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: theme.spacing[2],
            }}
          >
            <Skeleton style={{ height: 83 }} />
            <Skeleton style={{ height: 50 }} />
          </div>
          <Skeleton style={{ height: 56, borderRadius: theme.radius[3] }} />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            gap: theme.spacing[5],
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: theme.spacing[4],
            }}
          >
            <Skeleton style={{ width: 160, height: 28 }} />
            <div
              style={{
                display: 'grid',
                gridTemplateRows: 'repeat(1, 1fr)',
                gridTemplateColumns: 'repeat(3, 1fr)',
                columnGap: theme.spacing[3],
                rowGap: theme.spacing[3],
              }}
            >
              <Skeleton style={{ width: 188, height: 94 }} />
              <Skeleton style={{ width: 188, height: 94 }} />
              <Skeleton style={{ width: 188, height: 94 }} />
              <Skeleton style={{ width: 188, height: 94 }} />
              <Skeleton style={{ width: 188, height: 94 }} />
              <Skeleton style={{ width: 188, height: 94 }} />
            </div>
          </div>
          <Skeleton style={{ height: 130 }} />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: theme.spacing[4],
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: theme.spacing[5],
              }}
            >
              <Skeleton style={{ flex: 1, height: 38 }} />
              <Skeleton style={{ flex: 1, height: 38 }} />
            </div>
            <Skeleton style={{ width: 168, height: 38, alignSelf: 'center' }} />
          </div>
        </div>
      </div>
      <Skeleton style={{ height: 200 }} />
    </div>
  );
}
